import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import Nav from 'react-bootstrap/lib/Nav';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import HeaderModal from '../../HeaderModal';

import { adminLogout } from '../../../actions/siteadmin/logout';
import { openHeaderModal } from '../../../actions/modalActions';
import checkUserStatusQuery from './getCheckUserStatus.graphql';
import { formatLocale } from '../../../helpers/formatLocale';
import messages from '../../../locale/jsonMessages';
import { withQuery } from '../../../hoc/withGraphql';
import { AdminHeaderGoToMainSiteIcon, AdminHeaderLanguageIcon, AdminHeaderLogoutIcon } from '../../Common/Assets/SvgIconComponent/AdminHeaderIcon';

import s from './AdminNavigation.css';
class AdminNavigation extends React.Component {

  static propTypes = {
    className: PropTypes.string,
  };

  render() {
    const { openHeaderModal, currentLocale, adminLogout } = this.props;
    const { checkLoginUserExist: { userExistloading, getUserExists } } = this.props;
    if (!userExistloading && getUserExists) {
      if (getUserExists.status == 400) {
        const isBrowser = typeof window !== 'undefined';
        if (isBrowser) {
          adminLogout();
        }
      }
    }
    return (
      <Nav className={s.adminHeaderNavMenuContainer}>
        <div onClick={(e) => openHeaderModal('languageModal')} className={s.adminHeaderMenuItem} tabIndex={0}>
          <span className={s.adminHeaderMenuItemIconBox}>
            <AdminHeaderLanguageIcon className={s.adminHeaderMenuItemIcon} />
          </span>
          <span className={s.adminHeaderMenuItemText}>{formatLocale(currentLocale)}</span>
        </div>
        <a href="/" className={s.adminHeaderMenuItem}>
          <span className={s.adminHeaderMenuItemIconBox}>
            <AdminHeaderGoToMainSiteIcon className={s.adminHeaderMenuItemIcon} />
          </span>
          <span className={s.adminHeaderMenuItemText}>
            <FormattedMessage {...messages.GotoMainSite} />
          </span>
        </a>
        <form action={'/admin-logout'} method="post">
          <button type="submit" className={s.adminHeaderMenuItem}>
            <span className={s.adminHeaderMenuItemIconBox}>
              <AdminHeaderLogoutIcon className={s.adminHeaderMenuItemIcon} />
            </span>
            <span className={s.adminHeaderMenuItemText}><FormattedMessage {...messages.logout} /></span>
          </button>
        </form>
        <HeaderModal hideCurrencyModal={true} />
      </Nav>
    );
  }

}

const mapState = state => ({
  currentLocale: state.intl.locale
});
const mapDispatch = {
  openHeaderModal,
  adminLogout
};

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
  withQuery(checkUserStatusQuery, {
    name: 'checkLoginUserExist',
    options: {
      ssr: false,
      pollInterval: 5000,
      fetchPolicy: 'network-only'
    }
  })
)(AdminNavigation);